import { createSelector } from 'redux-starter-kit';
const cipSelector = (state: any) => state.cip;

export const cipSelectors = {
  getCipCategories: createSelector(
    cipSelector,
    subState => subState.cip_categories
  ),
  getMpsFirms: createSelector(cipSelector, subState => subState.mps_firms)
};
